<div class="task__container flex">
  <div class="task__table-header">
    <div class="task__table-header-container">
      <div>
        <form [formGroup]="taskFilterForm">
          <div class="grid task-filter-grid">
            <div class="task-filter-col">
              <div class="task__input-field">
                <label for="status" class="task__input-header">Task Status</label>
                <mat-form-field>
                  <mat-select
                    id="status"
                    formControlName="taskStatusId"
                    placeholder="All"
                    aria-label="Task Status"
                    data-pw="status-filter">
                    <mat-option [value]="null" [attr.data-pw]="'status-all'">All</mat-option>
                    @for (item of statuses(); track item.taskStatusId) {
                      <mat-option [value]="item.taskStatusId" [attr.data-pw]="'status-' + item.taskStatusId">
                        {{ item.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="task-filter-col">
              <div class="task__input-field">
                <label for="task-type" class="task__input-header">Task Name</label>
                <mat-form-field>
                  <mat-select
                    id="task-type"
                    formControlName="taskTypeId"
                    placeholder="All"
                    aria-label="Task Name"
                    data-pw="task-type-filter">
                    <mat-option [value]="null" [attr.data-pw]="'task-type-all'">All</mat-option>
                    @for (item of taskTypes(); track item.taskTypeId) {
                      <mat-option [value]="item.taskTypeId" [attr.data-pw]="'task-type-' + item.taskTypeId">
                        {{ item.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="task-filter-col task-filter-col--date-range">
              <div class="task__input-field">
                <label for="dueDateRange" class="task__input-header">Start - End dates</label>
                <app-date-range-picker
                  class="wider-datepicker"
                  [startDate]="taskFilterForm.get('dateRange')?.get('startDate')?.value ?? null"
                  [endDate]="taskFilterForm.get('dateRange')?.get('endDate')?.value ?? null"
                  (rangeChange)="onTaskDateRangeFilterChange($event)"
                  [dataPwPrefix]="'date-range-filter'"
                  [alignRight]="true"
                  [showTime]="false">
                </app-date-range-picker>
              </div>
            </div>
            <div class="task-filter-col">
              <div class="task__filter-button-container">
                <button
                  mat-raised-button
                  class="task__apply-filter-button"
                  (click)="applyFilter()"
                  data-pw="apply-filters">
                  Apply Filters
                </button>
                <button
                  mat-raised-button
                  class="task__clear-filter-button"
                  (click)="clearFilters()"
                  data-pw="clear-filters">
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="task__table-tab-container">
      <div
        class="task__header-tab"
        [class.selected-box-shadow]="isSelected(tableSelection.toDo)"
        [style.border-bottom]="getBorderWidth(tableSelection.toDo) + ' solid #206487'">
        <button
          mat-button
          class="task__header-tab-button hover-effect"
          (click)="toggleTabSelection(tableSelection.toDo)"
          data-pw="todoTab">
          <span class="task__header-tab-button-text" [class.bold]="isSelected(tableSelection.toDo)">To Do</span>
        </button>
      </div>
      <div
        class="task__header-tab"
        [class.selected-box-shadow]="isSelected(tableSelection.complete)"
        [style.border-bottom]="getBorderWidth(tableSelection.complete) + ' solid #206487'">
        <button
          mat-button
          class="task__header-tab-button custom-icon hover-effect"
          data-pw="completedTab"
          [class.black-tab-button]="isSelected(tableSelection.complete)"
          [class.grey-tab-button]="!isSelected(tableSelection.complete)"
          (click)="toggleTabSelection(tableSelection.complete)">
          <span class="task__header-tab-button-text" [class.bold]="isSelected(tableSelection.complete)"
            >Completed</span
          >
        </button>
      </div>
    </div>
  </div>
  <cfi-mat-table
    [data]="tasks()"
    [serverSidePaging]="true"
    [columnDefinitions]="columnDefinitions"
    [columnsToDisplayWithExpand]="columnsToDisplayWithExpand"
    [defaultPageSize]="defaultPageSize()"
    [currentPageSize]="pageSize"
    [totalRows]="totalCount"
    [currentPageIndex]="currentPageNumber - 1"
    [displayedColumns]="displayedColumns"
    [sortDirection]="sortDirection()"
    [sortKey]="sortBy()"
    [(expandedElement)]="expandedElement"
    (expandedElementChange)="onExpandedElementChange($event)"
    (cbPaginate)="updatePaging($event)"
    data-pw="tasksTable"
    (cbSort)="updateSort($event)">
    <!-- Header Template -->
    <ng-template #headerTemplate let-column>
      {{ column.header }}
    </ng-template>

    <!-- Cell Template -->
    <ng-template #cellTemplate let-task let-column="column">
      @switch (column.name) {
        <!-- Default Column -->
        @default {
          <td
            class="table-cell__icon-container"
            [attr.data-pw]="'cell-' + column.name">
            {{ task[column.name] | truncate: 32 }}
          </td>
        }
        @case ('taskStatus') {
          <td class="status-container" data-pw="statusCell" [style.padding-left]="!task.subCells ? '48px' : '0'">
            @if (getStatusIconConfig(task.taskStatus); as iconConfig) {
              @if (iconConfig.iconType === 'material') {
                <mat-icon
                  [style.color]="iconConfig.color"
                  [style.font-size.px]="20"
                  [style.height.px]="20"
                  [style.margin-right.px]="8"
                  [style.width.px]="20">
                  {{ iconConfig.iconName }}
                </mat-icon>
              } @else if (iconConfig.iconType === 'svg') {
                <mat-icon
                  [style.color]="iconConfig.color"
                  [style.font-size.px]="20"
                  [style.height.px]="20"
                  [style.margin-right.px]="8"
                  [style.width.px]="20"
                  [svgIcon]="iconConfig.iconName">
                </mat-icon>
              }
            }
            {{ task.taskStatus }}
          </td>
        }
        @case ('taskType') {
          <td
            class="table-cell__icon-container"
            [attr.data-pw]="'cell-' + column.name"
            [matTooltip]="task.taskType">
            {{ task.taskType }}
          </td>
        }
        @case ('description') {
          <td
            class="table-cell__icon-container"
            [attr.data-pw]="'cell-' + column.name"
            [matTooltip]="task.assignedStudentName && task.programPartnerTypeId === 3
              ? task.description + ' Student: ' + task.assignedStudentName
              : task.description">
            <div>{{ task.description }}</div>
            @if (task.programPartnerTypeId === 3 && task.assignedStudentName) {
              <div class="task-student-label">Student: {{ task.assignedStudentName }}</div>
            }
          </td>
        }
        @case ('dateCreated') {
          <td
            class="table-cell__icon-container"
            [attr.data-pw]="'cell-' + column.name">
            {{ task.dateCreated | date: 'MM/dd/yyyy' }}
          </td>
        }
        @case ('dueDate') {
          <td
            class="table-cell__icon-container"
            [attr.data-pw]="'cell-' + column.name">
            {{ task.dueDate | date: 'MM/dd/yyyy' }}
          </td>
        }
        @case ('action') {
          <td>
            <div class="table-cell__action-button-container">
              @if (shouldShowEditButton(task)) {
                <button
                  class="task-edit-button"
                  data-pw="editTask"
                  disableRipple="true"
                  mat-icon-button
                  [class.edit-disabled]="status === ProviderInfoStatus.Denied || task.completed"
                  [disabled]="status === ProviderInfoStatus.Denied || task.completed"
                  (click)="handleTaskButtonClicked(task)"
                  matTooltip="Edit Task"
                  aria-label="Edit Task">
                  <mat-icon class="edit-icon" svgIcon="k12-edit"></mat-icon>
                </button>
              }
            </div>
          </td>
        }
      }
    </ng-template>

    <!-- Expanded Content Template -->
    <ng-template #expandedRow let-subCell>
      @for (column of columnDefinitions; track column.name; let i = $index) {
        <div
          class="table-cell__icon-container"
          [attr.data-pw]="'expandedCell-' + column.name"
          [style.width.%]="column.expandedWidth"
          [style.display]="'flex'"
          [style.align-items]="'center'"
          [style.padding]="i === 0 ? '0 0 0 53px' : '0 8px'">
          <div class="subtask-content" style="width: 100%">
            @switch (column.name) {
              @case ('taskStatus') {
                <div class="flex align-items-center icon-subtask" style="gap: 10px">
                  @if (getStatusIconConfig(subCell.taskStatus); as iconConfig) {
                    @if (iconConfig.iconType === 'material') {
                      <mat-icon
                        [style.color]="iconConfig.color"
                        [style.font-size.px]="16"
                        [style.height.px]="16"
                        [style.width.px]="16">
                        {{ iconConfig.iconName }}
                      </mat-icon>
                    } @else if (iconConfig.iconType === 'svg') {
                      <mat-icon
                        [style.color]="iconConfig.color"
                        [style.font-size.px]="16"
                        [style.height.px]="16"
                        [style.width.px]="16"
                        [svgIcon]="iconConfig.iconName">
                      </mat-icon>
                    }
                  }
                  <span class="subtask-value icon-status" data-pw="subtaskStatus">
                    {{ subCell.taskStatus | truncate: 32 }}
                  </span>
                </div>
              }
              @case ('taskType') {
                <span class="subtask-value" [attr.data-pw]="'subtask-' + column.name">{{
                  subCell.name || subCell.taskType || subCell.parentTaskType | truncate: 32
                }}</span>
              }
              @case ('description') {
                <span class="subtask-value" [attr.data-pw]="'subtask-' + column.name">{{
                  subCell.description | truncate: 42
                }}</span>
              }
              @case ('dateCreated') {
                <span class="subtask-value" [attr.data-pw]="'subtask-' + column.name">
                  {{ subCell.createdDatetime || subCell.dateCreated | date: 'MM/dd/yyyy' }}
                </span>
              }
              @case ('dueDate') {
                <span class="subtask-value" [attr.data-pw]="'subtask-' + column.name">
                  {{ subCell.parentDueDate || subCell.dueDate | date: 'MM/dd/yyyy' }}
                </span>
              }
              @case ('action') {
                <div class="table-cell__action-button-container">
                  @if (shouldSubShowEditButton(subCell)) {
                    <button
                      mat-icon-button
                      data-pw="editSubtask"
                      class="task-edit-button"
                      [class.edit-disabled]="status === ProviderInfoStatus.Denied || subCell.completed"
                      [disabled]="status === ProviderInfoStatus.Denied || subCell.completed"
                      (click)="handleTaskButtonClicked(subCell)"
                      matTooltip="Edit Subtask"
                      aria-label="Edit Subtask">
                      <mat-icon svgIcon="k12-edit"></mat-icon>
                    </button>
                  }
                </div>
              }
              @default {
                <span class="subtask-value" [attr.data-pw]="'subtask-' + column.name">{{
                  subCell[column.name] | truncate: 42
                }}</span>
              }
            }
          </div>
        </div>
      }
    </ng-template>
  </cfi-mat-table>
</div>
